import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Indropped(state = initialState, action) {
  switch (action.type) {
    case userConstants.DROPPED_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.DROPPED_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.DROPPED_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}